
import { Prop, Component, Vue } from "vue-property-decorator";
import { MobileQaItem } from "@/models/QaAnswer";

@Component
export default class MobileQuestion extends Vue {
  @Prop() public getIndex!: any;
  @Prop() public MobileQAList: MobileQaItem[];

  mounted() {
    this.scrollToTop();
  }

  updated() {
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }
}
